<template>
  <div class="change-primary-payment p-2">
    <div>
        
    </div>
    <h2 class="text-center my-2">{{ $t("lang.payment.title_change_payment_method") }}</h2>

    <template v-if="primaryPaymentMethod">
      <h4 class="mt-3 mb-2 font-weight-bold primary-payment-heading">
        {{ $t("lang.payment.primary_payment_actually") }}
      </h4>

      <div class="card mt-3 primary-payment-card">
        <span class="creation-date-badge">{{ primaryPaymentMethod.creation_date }}</span>
        <span
          v-if="primaryPaymentMethod.payment_type == 'sepa'"
          class="sepa-corner-badge"
        >
          <img width="30" src="@/assets/images/sepa.png" alt="SEPA" />
        </span>
        <div
          class="body primary-card-body"
          :class="{ 'primary-card-body--sepa': primaryPaymentMethod.payment_type == 'sepa' }"
        >
          <div
            class="table-responsive table-transactions"
            :class="primaryPaymentMethod.default === '1' ? 'title' : ''"
          >
            <div v-if="primaryPaymentMethod.payment_type == 'cc'">
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Brand</span>
                <img width="30" :src="typeBrand(primaryPaymentMethod.brand)" :alt="primaryPaymentMethod.brand" />
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Card Number</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.card_number }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Card Owner</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.name_on_card }}</span>
              </div>
              <div
                v-if="primaryPaymentMethod.expiration_year != null || primaryPaymentMethod.expiration_month != null"
                class="d-flex justify-content-between mb-1"
              >
                <span class="detail-label">Expiration Date</span>
                <span class="font-weight-bold">
                  {{ primaryPaymentMethod.expiration_month }} / {{ primaryPaymentMethod.expiration_year }}
                </span>
              </div>
            </div>
            <div v-else>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">ID SEPA Number</span>
                <span class="font-weight-bold">{{ sepaDisplayId(primaryPaymentMethod) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Bank Account</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.bank_account_name }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">IBAN</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.iban }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">SWIFT BIC</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.swift_bic }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Adress Line (1)</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.address_line_1 }}</span>
              </div>
              <div
                v-if="primaryPaymentMethod.address_line_2 != null"
                class="d-flex justify-content-between mb-1"
              >
                <span class="detail-label">Adress Line (2)</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.address_line_2 }}</span>
              </div>
              <div
                v-if="primaryPaymentMethod.signtory_name != null"
                class="d-flex justify-content-between mb-1"
              >
                <span class="detail-label">Signatory Name</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.signatory_name }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">Postal Code</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.postal_code }}</span>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="detail-label">City</span>
                <span class="font-weight-bold">{{ primaryPaymentMethod.city }}</span>
              </div>
            </div>
          </div>
          <div class="primary-card-footer d-flex justify-content-end align-items-center flex-wrap">
            <small
              v-if="primaryPaymentMethod.expired === '0'"
              class="badge btn-success mr-2 mb-0"
            >VALID</small>
            <small
              v-else-if="primaryPaymentMethod.expired === '1'"
              class="badge btn-warning mr-2 mb-0"
            >EXPIRES SOON</small>
            <small
              v-else-if="primaryPaymentMethod.expired === '2'"
              class="badge btn-danger mr-2 mb-0"
            >EXPIRED</small>
          </div>
        </div>
      </div>

      <div v-if="!alternativePaymentMethods.length" class="alert alert-light border text-center alternatives-after-primary mb-0">
        {{ $t("lang.payment.no_payment_methods") }}
      </div>

      <div v-else class="alternatives-after-primary alternatives-block">
        <p class="alternatives-instruction mb-3">
          {{ $t("lang.payment.choose_payment_method") }}
        </p>
        <div
          v-for="payment in alternativePaymentMethods"
          :key="payment.id"
          class="d-flex align-items-center alternative-row mt-3"
        >
          <div class="alternative-radio-wrap pr-3">
            <input
              type="radio"
              class="alternative-radio"
              name="change-primary-alternative"
              :value="payment.id"
              v-model="selectedMethodId"
              @change="onAlternativeSelected()"
            />
          </div>
          <div class="card flex-grow-1 alternative-card mb-0">
            <div class="body p-3">
              <div v-if="payment.payment_type == 'cc'" class="alternative-summary">
                <div class="alternative-line">
                  <img width="36" :src="typeBrand(payment.brand)" :alt="payment.brand" />
                </div>
                <div class="alternative-line font-weight-bold card-number-mask">
                  {{ payment.card_number }}
                </div>
                <div class="alternative-line font-weight-bold">
                  {{ payment.name_on_card }}
                </div>
              </div>
              <div v-else class="alternative-summary">
                <div class="alternative-line">
                  <img width="36" src="@/assets/images/sepa.png" alt="SEPA" />
                </div>
                <div class="alternative-line font-weight-bold">
                  {{ sepaDisplayId(payment) }}
                </div>
                <div class="alternative-line font-weight-bold">
                  {{ payment.bank_account_name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="cancelChangePrimary"
          >
            {{ $t("lang.button.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary themed-button"
            :disabled="!selectedMethodId"
            @click="confirmChangePrimaryPayment(typeMethodSelected)"
          >
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { billingsService } from "@/_services";
export default {
  name: "ChangeClientPaymentMethod",
  props: {
    paymentMethods: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedMethodId: null,
      typeMethodSelected: null,
    };
  },
  computed: {
    primaryPaymentMethod() {
      return (this.paymentMethods || []).find((p) => p.default === "1") || null;
    },
    alternativePaymentMethods() {
      return (this.paymentMethods || []).filter((p) => p.default !== "1");
    },
  },
  watch: {
    /**
     * Si `paymentMethods` se actualiza (p. ej. tras refrescar desde el padre) y el id
     * elegido ya no está en alternativas, o no queda ninguna, limpiamos el radio.
     */
    alternativePaymentMethods: {
      handler(list) {
        if (!list.length) {
          this.selectedMethodId = null;
        } else if (
          this.selectedMethodId &&
          !list.some((p) => String(p.id) === String(this.selectedMethodId))
        ) {
          this.selectedMethodId = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    typeBrand(brand) {
      switch (brand) {
        case "Visa":
          return require("@/assets/images/visa-logo.png");
        case "CB":
          return require("@/assets/images/cb-logo.png");
        case "Mastercard":
          return require("@/assets/images/mc-logo.png");
        default:
          return undefined;
      }
    },
    sepaDisplayId(payment) {
      return `EDI${String(payment.id).padStart(10, "0")}`;
    },
    onAlternativeSelected(payment) {
      console.log(this.alternativePaymentMethods);
      console.log(this.selectedMethodId);
      this.alternativePaymentMethods.forEach(method => {
        if (method.id === this.selectedMethodId) {
          this.typeMethodSelected = method;
        }
      });
      console.log(this.typeMethodSelected);
    },
    cancelChangePrimary() {
      this.$emit("cancel");
    },
    confirmChangePrimaryPayment(payment) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (!result.value) {
          return;
        }
        const payload = { ...payment, default: "1" };
        let success = false;
        this.$emit("change-primary-loading", true);
        billingsService
          .saveSepaPaymentMethod(payload)
          .then(() => {
            success = true;
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.payment.paymentmethodchangedsuccesfully"),
              showConfirmButton: false,
              timer: 7000,
            });
          })
          .catch(() => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: false,
              timer: 7000,
            });
          })
          .finally(() => {
            this.$emit("change-primary-loading", false);
            this.$emit("change-primary-done", { success });
          });
      });
    },
  },
};
</script>

<style scoped>
.primary-payment-heading {
  font-size: 1.05rem;
}

.primary-payment-card {
  position: relative;
}

.primary-card-body {
  /* Espacio para la fecha absoluta (esquina sup. izq.) sin pisar la primera fila */
  padding: 1.6rem 1rem 0.35rem;
}

.primary-card-body--sepa {
  /* Fecha (arriba) + logo SEPA (debajo de la fecha); margen izq. para no solapar el icono */
  padding-top: 3.35rem;
  padding-left: 2.85rem;
  padding-right: 1rem;
  padding-bottom: 0.35rem;
}

.primary-card-body .table-transactions {
  min-height: 0;
  margin-bottom: 0;
}

.primary-card-footer {
  margin-top: 0.25rem;
  padding-top: 0.25rem;
}

.alternatives-after-primary {
  margin-top: 2.5rem;
}

.alternatives-instruction {
  font-size: 0.95rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}

.creation-date-badge {
  position: absolute;
  top: 6px;
  left: 7px;
  font-size: 0.6rem;
}

.sepa-corner-badge {
  position: absolute;
  top: 20px;
  left: 7px;
  font-size: 0.6rem;
}

.detail-label {
  font-size: 0.8rem;
}

.alternative-row {
  min-height: 48px;
}

.alternative-radio-wrap {
  flex-shrink: 0;
  align-self: center;
}

.alternative-radio {
  width: 1.1rem;
  height: 1.1rem;
  cursor: pointer;
}

.alternative-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.alternative-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.alternative-line {
  line-height: 1.25;
}

.card-number-mask {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>
